/* eslint-disable */
export default {
  searchPlaceholder: 'Pesquisar…',
  refresh: 'Atualizar',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
